import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faSun, 
  faCloud, 
  faCloudSun, 
  faCloudRain, 
  faCloudShowersHeavy,
  faCloudBolt,
  faSnowflake,
  faSmog,
  faWind,
  faMoon,
} from '@fortawesome/free-solid-svg-icons';

const WeatherIcon = ({ code, isDay, localDayTime }) => {
  if (localDayTime) {
    return <FontAwesomeIcon icon={faSun} />
  } else {
    return <FontAwesomeIcon icon={faMoon} />
  }

  const getWeatherIcon = (weatherCode) => {
    switch (true) {
      // Sunny and Clear Conditions
      case [1000].includes(weatherCode):
        return isDay || localDayTime? faSun: faMoon;
      
      // Partly Cloudy
      case [1003].includes(weatherCode):
        return faCloudSun;
      
      // Cloudy and Overcast
      case [1006, 1009].includes(weatherCode):
        return faCloud;
      
      // Misty and Foggy Conditions
      case [1030, 1135, 1147].includes(weatherCode):
        return faSmog;
      
      // Rain Conditions
      case [1063, 1180, 1183, 1186, 1189, 1192, 1195, 1240, 1243, 1246].includes(weatherCode):
        return faCloudRain;
      
      // Heavy Rain and Thunderstorms
      case [1273, 1276, 1087].includes(weatherCode):
        return faCloudBolt;
      
      // Light Drizzle
      case [1150, 1153, 1168, 1171].includes(weatherCode):
        return faCloudShowersHeavy;
      
      // Snow Conditions
      case [1066, 1210, 1213, 1216, 1219, 1222, 1225, 1255, 1258, 1279, 1282].includes(weatherCode):
        return faSnowflake;
      
      // Blizzard and Extreme Conditions
      case [1114, 1117].includes(weatherCode):
        return faWind;
      
      // Default icon
      default:
        return faCloud;
    }
  };

  return <FontAwesomeIcon icon={getWeatherIcon(code)} />;
};

export default WeatherIcon;
